import { Observable } from 'rxjs';
import { FusionApiHttpClient } from '../../shared/_services/server-clients';

export interface CreateDealPayload {
  description: string;
  notes: string;
  publisherId: number | null;
  publisherDealPackageSovs: Array<{
    thinPublisherDealPackage: { packageId: number; publisherId?: number };
    sovPercent: number;
  }>;
  buyers: Array<{
    dspAccount: { id: number };
    defaultBidfloor: number;
    buyerType: string;
    status: string;
    wseat: null;
    wadomain: null;
    bcatExclusions: null;
    useImpBidfloor: 0;
    pubDealBuyerId: null;
    pubDeal: null;
    maxDataFee: string;
  }>;
  status: string;
  dealStart: string;
  dealEnd: string;
  configType: string;
  dealType: string;
  auctionType: string;
  bidfloorCurrency: string;
  marketplaceMode: boolean;
  paceReqs: number;
  platformfeeType: string;
  isPublisherTargeted: boolean;
  externalDealId: string;
  adpodSlotTarget: string;
  customPlatformfeeType: null;
  customPlatformfee: null;
  bizdevOwner: { id: number };
  marketplaceDescription: null;
  marketplaceRepresentedGroups: null;
  bundledDealIds: null;
  padAgreement: null;
  overallImpCap: null;
  frequencyCapDaily: null;
  frequencyCapMonthly: null;
  dailyReqCap: null;
  dailyImpCap: null;
  revenueCap: null;
  dayParting: null;
}

export class DealsApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  createDeal(payload: CreateDealPayload): Observable<{ pubDealId: number }> {
    return this.fusionApiHttpClient.plain.post<{ pubDealId: number }, CreateDealPayload>('deal/', payload);
  }

  deleteDeal(pubDealId: number): Observable<void> {
    return this.fusionApiHttpClient.plain.delete<void>(`deal/${pubDealId}`);
  }
}
